import { render, staticRenderFns } from "./AuthVerifyAccountView.vue?vue&type=template&id=2529af70&scoped=true"
import script from "./AuthVerifyAccountView.vue?vue&type=script&lang=js"
export * from "./AuthVerifyAccountView.vue?vue&type=script&lang=js"
import style0 from "./AuthVerifyAccountView.vue?vue&type=style&index=0&id=2529af70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2529af70",
  null
  
)

export default component.exports